import React,{useEffect,useState} from 'react';
import { Col, Container, Row } from 'react-bootstrap'
import * as AuthVerify from '../../lib/common';
import Axios from '../../lib/axios/axiosInstance';
import { Space, Table } from 'antd';
import { Link } from "react-router-dom";
import CCaC from './CostCenterAndCatalog'
import Loader from '../Common/loader';
import "./Dashboard.styles.css";
import { Slide, toast } from 'react-toastify';

const pendingOrderColumns = [
  {
      title: 'Order #',
      key: 'refnum',
      dataIndex: 'refnum',
  },
  {
    title: 'Submitted Date',
    dataIndex: 'submitteddate',
    render: (_, record) => (
      <>
        {record && record.submitteddate ? record.submitteddate.split('T')[0]:""}
      </>
    )
  },
  {
    title: 'Cost Center Name',
    dataIndex: 'ccname',
    key: 'ccname',
  },
  {
    title: 'Catalog Name',
    dataIndex: 'catalogname',
    key: 'catalogname',
  },
  {
    title: 'Order Total',
    dataIndex: 'totalamt',
    key: 'totalamt',
  },
  {
    title: 'PO No',
    dataIndex: 'ponum',
    key: 'ponum',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    // render: (_, record) => (
    //   <>
    //     {record.status=='D'?'Pending':''}
    //   </>
    // )
  },
  {
    title: '',
    key: 'action',
    render: (_, record) => (
      <>
        <Link to={`/pending-order?refnum=${record.refnum}`}>View Order</Link>
      </>
    ),
  },
];
// #endregion


const Dashboard = ({acccountDetails}) => {

  const [draftOrder, setDraftOrder] = useState(false);
  const [pendingOrder, setPendingOrder] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      const user = AuthVerify.getUser();
      if (user && user.role) {
        // Draft Details
        await AuthVerify.getDraftDeatils(true).then(data => {
          if (data) setDraftOrder(data);
          else setDraftOrder([]);
        })

        //GetListOfOrderPendingforApproval
        //https://devb2b.bizpoint-intl.com:3082/api/account/task
        await Axios.get(`/account/task`)
          .then(async (data) => {
            if (data.data?.data?.pendingapproval) {
              setPendingOrder(data.data?.data?.pendingapproval);
            }
            else {
              setPendingOrder([]);
            }
          });
      }
    }

    loadData();
  }, [])

  const shareDraftOrder = async (refnum) => {
    await Axios.post(`/cart/updatestatus/${refnum}`, { status: { newstatus: "common" } })
      .then(async (data) => {
        if (data.data?.data?.updatecartstatus === '1') {
          toast.success('Draft shared successfully.', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
          });
          await AuthVerify.getDraftDeatils(true).then(draftData => {
            if (draftData) setDraftOrder(draftData);
            else setDraftOrder([]);
          })
        } else {
          toast.error('Sharing failed!', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })
  }

  // #region Custom Table
  const draftOrderColumns = [
    {
      title: 'Order #',
      key: 'refnum',
      dataIndex: 'refnum',
    },
    {
      title: 'Cost Center',
      dataIndex: 'ccname',
      key: 'ccname',
    },
    {
      title: 'Catalog',
      dataIndex: 'catalogname',
      key: 'catalogname',
    },
    {
      title: 'PO No.',
      dataIndex: 'ponum',
      key: 'ponum',
    },
    // {
    //   title: 'Status',
    //   dataIndex: 'status',
    //   render: (_, record) => (
    //     <>
    //       {record.status=='D'?'Pending':''}
    //     </>
    //   )
    // },
    {
      title: '',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Link to={`/pending-order?refnum=${record.refnum}&draftOrder=true`}>View Draft</Link>
          <a onClick={(e) => shareDraftOrder(record.refnum)}>Set as Shared</a>
        </Space>
      ),
    },
  ];
  
  return (
    <div className="col-main">
      <div className="my-account">
        <div className="page-title">
          <h2 style={{ paddingTop: "12px" }}>Dashboard</h2>
        </div>
        <div className="dashboard">
          {acccountDetails &&
            <div className="welcome-msg">
              <h4>Hello, {acccountDetails.firstname}</h4>
              <p>
                From your Dashboard you have the ability to manage and select Cost Center and
                Catalog to load to your cart.
                <br />
                Select below to view cart information.
              </p>
            </div>
          }
          <hr />
            <CCaC acccountDetails={acccountDetails}/>

          {draftOrder ? <>
            <Col md={12} style={{ padding: "0px" }}>
              <h4 style={{ float: "left", textDecoration: "none", fontWeight: "bold" }}>Draft Orders</h4>
            </Col>
            <Table locale={{ emptyText: 'No Draft Orders Found !' }} className="osya table table-bordered jtv-cart-summary" style={{ marginTop: "20px" }} columns={draftOrderColumns} dataSource={draftOrder} pagination={draftOrder.length > 10} /></> : <Loader />}
            {pendingOrder ? <>
            <hr/>
            <Col md={12} style={{padding:"0px"}}>
                <h4 style={{float:"left", textDecoration:"none", fontWeight:"bold"}}>Pending Orders</h4>
            </Col>
            <Table locale={{ emptyText: 'No Pending Orders Found !' }} className="osya table table-bordered jtv-cart-summary" style={{marginTop:"20px"}} columns={pendingOrderColumns} dataSource={pendingOrder} pagination={pendingOrder.length>10} />
            </>:<Loader/>}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
